export default __webpack_public_path__ + "static/media/SizingOne.91f1e15a.png";